import { createSlice } from '@reduxjs/toolkit'

export const navSlice = createSlice({
    name: 'nav',
    initialState: {
        value: "Home"
    },
    reducers: {
        change: (state, action) => {
            state.value = action.payload
        }
    }
})

export const { change } = navSlice.actions

export default navSlice.reducer